import { render } from "./Sessions.vue?vue&type=template&id=26255560&scoped=true"
import script from "./Sessions.vue?vue&type=script&lang=js"
export * from "./Sessions.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-26255560"

export default script